// converts string with comma (and optional grouping dot) to floating number
export const parseStringToFloat = (
  value: string | undefined,
  language: string
): number => {
  if (!value) return 0.0;

  // replace , with .
  let newValue: string;
  switch (language) {
    case "en":
      // delete any ,
      newValue = value.replace(/,/g, "");
      break;
    default: {
      // delete any .
      newValue = value.replace(/\./g, "");

      // replace , with .
      newValue = newValue.replace(/,/g, ".");
    }
  }

  return parseFloat(newValue);
};

// return capitalized string
export const capitalize = (s: unknown): string => {
  if (typeof s !== "string") {
    return "";
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const camelToFlat = (camel: string) => {
  const camelCase = camel.replace(/([a-z])([A-Z])/g, "$1 $2");

  return camelCase;
};
